import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'prlw-file-upload-progress',
  templateUrl: './file-upload-progress.component.html',
  styleUrls: ['./file-upload-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadProgressComponent {
  @Input() public progress!: number;

  public get calculateProgressPercent(): number {
    return this.progress;
  }
}
